<template>
    <div class="smart-textarea">
        <textarea-autosize
                class="form-control"
                :placeholder="placeholder"
                v-model="internalValue"
                @keydown.native="onTextAreaKeyDown"
                @keyup.native="onTextAreaKeyUp"
                :maxlength="maxlength"
                ref="textarea">
        </textarea-autosize>
        <div class="backdrop" :style="{ width: textareaWidth, height: textareaHeight }">
            <div class="highlights form-control" v-html="highlightsHtml"></div>
        </div>
    </div>
</template>

<script>
    //import { observationVariableRegex } from '@/utils/observationVariables';

    export default {
        name: 'smart-textarea',
        props: {
            value: {
                required: false,
            },
            maxlength: {
                required: false,
            },
            placeholder: {
                required: false,
            },
        },
        data() {
            return {
                internalValue: this.value,
                highlightsHtml: null,
                textareaWidth: 0,
                textareaHeight: 0,
            }
        },
        watch: {
            value(value, oldValue) {
                if (value !== oldValue) {
                    this.internalValue = value;
                }
            },
            internalValue(value, oldValue) {
                this.calculateHighlight();

                if (value !== oldValue) {
                    this.$emit('input', value)
                }
            }
        },
        mounted() {
            this.internalValue = this.value;

            this.$nextTick(() => {
                this.calculateHighlight();
            });
        },
        methods: {
            calculateHighlight() {
                let highlightsHtml = this.internalValue;

                /*highlightsHtml = highlightsHtml
                    .replace(/\n$/g, '\n\n')
                    .replace(observationVariableRegex, '<mark>$1</mark>');*/

                let textareaElement = this.$refs.textarea.$el;

                this.textareaWidth = textareaElement.offsetWidth + 'px';
                this.textareaHeight = textareaElement.offsetHeight + 'px';

                console.log(this.textareaWidth, this.textareaHeight);

                this.highlightsHtml = highlightsHtml;
            },
            onTextAreaKeyDown(e) {
                this.$emit('keydown', e);
            },
            onTextAreaKeyUp(e) {
                this.$emit('keyup', e);
            }
        }
    }
</script>

<style lang="scss">
    .smart-textarea {
        position: relative;

        textarea {
            position: absolute;
            top: 0;
            left: 0;
            background: transparent !important;
        }

        .backdrop {
            overflow: auto !important;
            background: #fff !important; /* or whatever */
        }

        mark {
            padding: 0;
            background-color: #dedede; /* or whatever */
            color: transparent;
        }

        .highlights {
            color: transparent;
            background: transparent;
            width: 100%;
            height: 100%;
            white-space: pre-wrap;
            word-wrap: break-word;
        }
    }
</style>